import { Component } from 'react'
import { mvToTemp, tempToMv } from '../../../utils/ntc'
import { getString } from '../../../locale'
import classnames from 'classnames'
import { getLocale } from '../../../locale'

type Props = {
    label: string
    value: number | string
    onInput: (value: string) => void
    error: boolean
    errorRenderer: () => JSX.Element | boolean
    className?: string
}

type State = {
    celsius: number | string
}

class TemperatureInput extends Component<Props, State> {
    state: State = {
        celsius: mvToTemp(Number(this.props.value))[0],
    }

    componentDidUpdate = (prevProps: Props) => {
        if (prevProps.value !== this.props.value) {
            this.setState({ celsius: mvToTemp(Number(this.props.value))[0] })
        }
    }

    handleMvInput(e: any) {
        this.props.onInput(e.target.value)
        this.setState({ celsius: mvToTemp(Number(this.props.value))[0] })
    }

    handleCelsiusInput(e: any) {
        this.setState({ celsius: e.target.value })
        this.props.onInput(String(tempToMv(Number(e.target.value))))
    }

    render() {
        return (
            <>
                <div className={classnames('grid grid-cols-1', this.props.className)}>
                    <div className="hidden">
                        <label className="dark:text-white text-sm">
                            {this.props.label} ({getString('common.mv')})
                        </label>
                        <input
                            className={classnames('pretty-input', this.props.error ? 'border-red-500' : 'border-gray-300')}
                            value={this.props.value}
                            type="number"
                            onInput={this.handleMvInput.bind(this)}
                        />
                    </div>
                    <div>
                        <label className="dark:text-white text-sm">
                            {this.props.label} ({getString('common.celsius')})
                        </label>
                        <input
                            className={classnames('pretty-input', this.props.error ? 'border-red-500' : 'border-gray-300')}
                            style={getLocale() === 'he' ? { direction: 'ltr', textAlign: 'right' } : undefined}
                            value={this.state.celsius}
                            type={getLocale() === 'he' ? 'text' : 'number'} // because appearance: none won't remove the arrows
                            onInput={this.handleCelsiusInput.bind(this)}
                        />
                    </div>
                </div>
                {this.props.errorRenderer()}
            </>
        )
    }
}

export default TemperatureInput
